exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amap-sug-result {\n  z-index: 999999999 !important;\n}\n", ""]);

// exports
